import { useEffect } from "react";
import { api } from "../lib/api";

export default function GoogleAnalytics() {
  useEffect(() => {
    let cancelled = false;
    api.get("/settings/public").then((r) => {
      if (cancelled) return;
      const gid = (r.data?.ga_measurement_id || "").trim();
      if (!gid || !/^G-[A-Z0-9-]+$/i.test(gid)) return;
      // Avoid duplicate injection
      if (document.querySelector(`script[data-ga-id="${gid}"]`)) return;
      const s1 = document.createElement("script");
      s1.async = true;
      s1.src = `https://www.googletagmanager.com/gtag/js?id=${gid}`;
      s1.setAttribute("data-ga-id", gid);
      document.head.appendChild(s1);
      const s2 = document.createElement("script");
      s2.setAttribute("data-ga-id", gid);
      s2.text = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${gid}');`;
      document.head.appendChild(s2);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return null;
}
